import Button from '@rio-cloud/rio-uikit/Button';
import { FormattedMessage } from 'react-intl';

import { OverlayTrigger, Tooltip } from '../../common/utils/tooltipReExports';
import { DEFAULT_TOOLTIP_DELAY } from '../../config/config';

const MAN_NOW_PATHS: Record<string, string> = {
    'man-sku00000060': 'https://mannow.rio.cloud/availableFeatures/MOT/details',
    'man-sku00000072': 'https://mannow.rio.cloud/availableFeatures/EFFICIENT_ROUTE/details',
    'man-sku00000076': 'https://mannow.rio.cloud/availableFeatures/ONLINE_NEWS/details',
};

interface Props {
    productId: string;
}

export const ManageInManNowButton = ({ productId }: Props) => {
    const lowerCaseProductId = productId.toLowerCase();
    const targetPath = MAN_NOW_PATHS[lowerCaseProductId];

    if (!targetPath) {
        return null;
    }

    const linkButton = (
        <Button
            as='a'
            className='btn btn-default'
            href={targetPath}
            target='_blank'
            rel={'noreferrer'}
            autoTrackingKey='marketplace.contracts.button.mannow'
        >
            <span className={'uikit-icon icon-info-sign'} />
            <FormattedMessage id='marketplace.contracts.button.mannow' />
        </Button>
    );

    return (
        <OverlayTrigger
            trigger={OverlayTrigger.TRIGGER_HOVER}
            placement='left'
            overlay={
                <Tooltip id='legacy-tooltip'>
                    <FormattedMessage id='marketplace.contracts.tooltip.mannow' />
                </Tooltip>
            }
            delay={DEFAULT_TOOLTIP_DELAY}
        >
            <span className='margin-right-15'>{linkButton}</span>
        </OverlayTrigger>
    );
};
